import axios from "../services/api/api";
import { AUTH_BASE_URL } from "../constants/api.constants";

export const AUTHENTICATING = "AUTHENTICATING";
export const AUTHENTICATED = "AUTHENTICATED";
export const UNAUTHENTICATED = "UNAUTHENTICATED";
export const AUTHENTICATION_ERROR = "AUTHENTICATION_ERROR";

export const signInAction =
  ({ email, password }, history) =>
  async (dispatch) => {
    dispatch({
      type: AUTHENTICATING,
      payload: {
        isLoggingIn: true,
        error: null,
      },
    });

    await axios
      .post(`${AUTH_BASE_URL}/token/auth`, {
        email: email,
        password: password,
        grant_type: "password",
      })
      .then((res) => {
        if (res.data.result.code === "999") {
          var t = JSON.parse(res.data.result.data);

          var jwtDecode = require("jwt-decode");
          var tfix = jwtDecode(t.access_token);
          var keys = Object.values(tfix);
          var roles = [];
          roles = keys[3];

          axios.defaults.headers.common["Authorization"] = t.access_token;
          localStorage.setItem("token", t.access_token);
          localStorage.setItem("refresh_token", t.refresh_token);
          localStorage.setItem("email", res.data.result.email);
          localStorage.setItem("role", roles);

          // setTimeout(() => {
          dispatch({
            type: AUTHENTICATED,
            payload: {
              token: t.access_token,
              refresh_token: t.refresh_token,
              code: res.data.result.code,
              message: res.data.result.message,
              exp: tfix.exp,
              email: res.data.result.email,
              roles: roles,
              error: null,
              isLoggingIn: false,
            },
          });

          // }, 500);
        } else {
          dispatch({
            type: AUTHENTICATION_ERROR,
            payload: {
              error: "signin.unauthorized",
              isLoggingIn: false,
            },
          });
        }
      })
      .catch((err) => {
        dispatch({
          type: AUTHENTICATION_ERROR,
          payload: {
            error: "signin.unauthorized",
            isLoggingIn: false,
            message: err.message,
          },
        });
      });
  };

export function signOutAction() {
  axios.defaults.headers.common["Authorization"] = null;
  localStorage.removeItem("token");
  localStorage.removeItem("refresh_token");
  localStorage.removeItem("email");
  localStorage.removeItem("role");
  localStorage.removeItem("schoolName");
  localStorage.removeItem("school");
  localStorage.removeItem("aplSupervisorHasRegistered");
  localStorage.removeItem("help");
  localStorage.removeItem("tmpEmail");
  localStorage.removeItem("tmpRole");
  localStorage.removeItem("showResult");
  return {
    type: UNAUTHENTICATED,
  };
}
